import BeniftContent from "../dao/BeniftContent";

const HowItWorks = () => {
  return (
    <>
      {/* <!-- Process / CTA --> */}
      <section className="py-24 dark:bg-jacarta-800">
        <div className="container">
          <div className="mx-auto mb-12 text-center">
            <h2 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
              HOW IT WORKS
            </h2>
            <p className="text-lg dark:text-jacarta-300">
              Our Impact DOT (digital ownership token) campaigns are a great way
              to collaborate to raise funds with mutual benefits. Join a
              cause-driven community, support campaigns you care about, align
              with purposeful brands and influencers, and build an impact
              portfolio that benefits you and the planet. Here’s an overview of
              how it works.
            </p>
          </div>
          {/* End mx-auto */}

          <BeniftContent
            title="OUR WORLD OF "
            gradientText="IMPACT SHOWCASE "
            description="Immersive, fun interactions & learning that informs and paves the way
          for real-world solutions. An engaging, safe space to showcase
          sustainability activities and innovations, and encourage
          collaborations."
          />

          {/* <CallToActions /> */}
        </div>
      </section>
      {/* <!-- end process / cta -->  */}
    </>
  );
};

export default HowItWorks;
